var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TopKCardItem',{attrs:{"item":_vm.item,"index":_vm.index}})
}
var staticRenderFns = []

export { render, staticRenderFns }